import React from 'react';
import style from './line.module.scss';
import { LineInterface } from './lineTypes';

const Line: React.FC<LineInterface> = ({ width, height }) => {
  const size = {
    maxWidth: `${width}px`,
    height: `${height}px`,
  };

  return <div className={style.line} style={size} />;
};

export default Line;
